import {initMap} from './map';
import {initSearchBox} from './search-box';
import {initGeoLocation} from './geolocation';

function main() {
  initMap();
  initSearchBox();
  initGeoLocation();

  document.querySelector('#app').classList.remove('hide');
}

main();
